import React from 'react';

interface Props { children: React.ReactNode; }
interface State { hasError: boolean; error: Error | null; errorInfo: React.ErrorInfo | null; }

export class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    this.setState({ errorInfo });
    console.error('[ErrorBoundary] Caught:', error.message, error.stack);
    console.error('[ErrorBoundary] Component stack:', errorInfo.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '40px', fontFamily: 'monospace', color: '#ff6b6b', background: '#0a0a0a', minHeight: '100vh' }}>
          <h1 style={{ color: '#fff', marginBottom: '16px' }}>GenofX crashed</h1>
          <p style={{ color: '#ccc', marginBottom: '24px' }}>The error below will help fix this:</p>
          <pre style={{ background: '#1a1a1a', padding: '16px', borderRadius: '8px', overflow: 'auto', fontSize: '12px', lineHeight: 1.6 }}>
            {this.state.error?.message}
            {'\n\n'}
            {this.state.error?.stack}
          </pre>
          {this.state.errorInfo && (
            <details style={{ marginTop: '16px' }}>
              <summary style={{ color: '#888', cursor: 'pointer' }}>Component stack</summary>
              <pre style={{ background: '#1a1a1a', padding: '16px', borderRadius: '8px', overflow: 'auto', fontSize: '11px', marginTop: '8px' }}>
                {this.state.errorInfo.componentStack}
              </pre>
            </details>
          )}
          <button 
            onClick={() => window.location.reload()}
            style={{ marginTop: '24px', padding: '10px 20px', background: '#6E1AF4', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer' }}
          >
            Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
